import Button from "@pathwright/ui/src/components/button/Button"
import PropTypes from "prop-types"
import "./ContentMethodEmbedCode.css"

// Use this component as a custom form input.
// See lib/core/components/form for spec.

const ContentMethodEmbedCode = function (props) {
  const { value, placeholder, load_prompt, onChange, onLoad } = props

  // Becomes ref to textarea so button can access value
  let textarea = null

  return (
    <div className="ContentMethod__EmbedCode">
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        ref={(node) => {
          return (textarea = node)
        }}
        placeholder={placeholder}
        rows={3}
      />
      <Button onClick={() => onLoad(textarea.value)} rounded={false}>
        {load_prompt}
      </Button>
    </div>
  )
}

ContentMethodEmbedCode.displayName = "ContentMethodEmbedCode"

ContentMethodEmbedCode.propTypes = {
  // Customize textarea placeholder
  placeholder: PropTypes.string.isRequired,
  // Customize load button text
  load_prompt: PropTypes.string.isRequired,
  // Pass up code
  onChange: PropTypes.func.isRequired,
  //
  onLoad: PropTypes.func.isRequired
}

ContentMethodEmbedCode.defaultProps = {
  placeholder: "Paste embed code...",
  load_prompt: "Load"
}

export default ContentMethodEmbedCode
